<template>
  <div>
    <Head :title="__(title)" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.date" :error="form.errors.date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Date')" />

          <div class="pr-6 pb-8 w-full">
            <label class="form-label mb-6">{{ __('Details') }}:</label>
            <div v-for="(detail, index) in form.details" :key="index" class="flex items-center space-x-4 mb-4">
              <select-input v-model="detail.asset_id" :error="form.errors[`details.${index}.asset_id`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Asset')" :required="true" @change="checkDuplicateAsset(detail, index)">
                <option :value="null">{{ __('Select Asset') }}</option>
                <option v-for="s in asset" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              <text-input v-model="detail.code" :error="form.errors[`details.${index}.code`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Code Asset')" readonly />
              <text-input v-model="detail.brand" :error="form.errors[`details.${index}.brand`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
              <text-input v-model="detail.type" :error="form.errors[`details.${index}.type`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')" readonly />
              <text-input v-model="detail.serial_number" :error="form.errors[`details.${index}.serial_number`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" readonly />
              <text-input v-model="detail.qty" :error="form.errors[`details.${index}.qty`]" type="number" min="1" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Qty')" @input="validateQty(index)" />
              <button type="button" @click="removeDetail(index)" class="text-red-500">
                {{ __('Remove') }}
              </button>
            </div>
            <button type="button" @click="addDetail" class="text-blue-500">
              {{ __('Add another asset') }}
            </button>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Create Incoming Goods') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create a new incoming goods' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    title: String,
    asset: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        date: null,
        details: [{ asset_id: null, code: '', brand: '', type: '', serial_number: '', qty: 1 }],
      }),
    }
  },
  watch: {
    'form.details': {
      handler(newDetails) {
        newDetails.forEach((detail, index) => {
          if (detail.asset_id) {
            const selectedAsset = this.asset.find((asset) => asset.id === detail.asset_id)
            if (selectedAsset) {
              this.form.details[index].code = selectedAsset.code
              this.form.details[index].brand = selectedAsset.brand
              this.form.details[index].type = selectedAsset.type
              this.form.details[index].serial_number = selectedAsset.serial_number
              if (!detail.qty) {
                this.form.details[index].qty = 1 // Set qty to 1 if it's not already set
              }
            }
          }
        })
      },
      deep: true,
    },
  },
  methods: {
    addDetail() {
      this.form.details.push({ asset_id: null, code: '', brand: '', type: '', serial_number: '', qty: 1 })
    },
    removeDetail(index) {
      this.form.details.splice(index, 1)
    },
    checkDuplicateAsset(detail, index) {
      const existingDetailIndex = this.form.details.findIndex((d, i) => d.asset_id === detail.asset_id && i !== index)

      if (existingDetailIndex !== -1) {
        this.form.details[existingDetailIndex].qty = parseInt(this.form.details[existingDetailIndex].qty) + parseInt(detail.qty || 1)
        this.form.details.splice(index, 1)
      } else if (!detail.qty) {
        this.form.details[index].qty = 1 // Set qty to 1 if it's not already set
      }
    },
    validateQty(index) {
      const qty = this.form.details[index].qty
      if (!qty || qty < 1) {
        this.form.details[index].qty = 1
      }
    },
    store() {
      this.form.post(this.route('incoming_goods.store'))
    },
  },
}
</script>
